// extracted by mini-css-extract-plugin
export default {"mainContainer":"NoNewNotificationTemplate_mainContainer__klWma","name":"NoNewNotificationTemplate_name__1wGQU"};